import React from 'react';
import { Layout, Tabs, Typography, Row, BackTop } from 'antd';
import { FireOutlined, BankOutlined } from '@ant-design/icons';

import 'antd/dist/antd.css';
import '../assets/css/offers.css';

import FoodItemsList from '../components/FoodItemsList';
import CouponsList from '../components/CouponsList';

const { TabPane } = Tabs;
const { Title, Text } = Typography;

const OffersPage = () => {
  const { Content } = Layout;

  return (
    <div>
      <Layout>
        <Content className="site-layout">
          <div className="site-layout-background">
            <div className="offers-top-card-wrapper"></div>
            <div className="site-card-wrapper">
              <Tabs defaultActiveKey="1">
                <TabPane
                  tab={
                    <span>
                      <FireOutlined />
                      Resturant Offers
                    </span>
                  }
                  key="1"
                >
                  <div className="margin-bottom15">
                    <Row>
                      <Title level={3}>All Offers(223)</Title>
                    </Row>
                    <Row>
                      <Text>
                        All offers and deals, from restaurants near you
                      </Text>
                    </Row>
                  </div>
                  <FoodItemsList />
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <BankOutlined />
                      Payment Offers/Coupons
                    </span>
                  }
                  key="2"
                >
                  <div className="margin-bottom15">
                    <Row>
                      <Title level={3}>Available Coupons(10)</Title>
                    </Row>
                  </div>
                  <CouponsList />
                </TabPane>
              </Tabs>
            </div>
          </div>
          <BackTop />
        </Content>
      </Layout>
    </div>
  );
};

export default OffersPage;
